// extracted by mini-css-extract-plugin
export default {"container":"Notfound_container__ff1Ka","animated":"Notfound_animated__vp8lU","wiggle":"Notfound_wiggle__vQGcB"};